import { CSSProperties } from "react"

import ClipLoader from "react-spinners/ClipLoader"

const LoadingIndicator = (props: any) => (
  <ClipLoader
    color={props.color || "#00A4E1"}
    loading={props.loading}
    size={props.size ?? 18}
    aria-label="Loading Spinner"
    data-testid="loader"
  />
)

export default LoadingIndicator
